import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    height: 100%;
    overflow: hidden;
  }
`;

const InnerContainer = styled.div`
  background: #ffffff;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 10px;
    height: 0px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px #bfbfbf;
    border-radius: 10px;
    margin: 42px 0px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 35px #e9e4ff;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    margin: 0 auto;

    ::-webkit-scrollbar {
      width: 8px;
      height: 0px;
    }
  }
`;

const CropArea = styled.div`
  position: relative;
  width: 542px;
  height: 300px;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    width: 100%;
    margin: 15px auto;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    margin-top: 15px;
  }

  button {
    margin: 25px 5px;
    min-width: 9.5em;

    @media screen and (max-width: 768px) {
      margin: 15px 5px;
    }
  }
`;

export { Container, CropArea, ButtonContainer, InnerContainer };
